import axios from 'axios';

/** Client for making requests without auth credentials, such as sign-in requests */
export const publicClient = axios.create({});

/** Client for making requests with auth credentials, such as apartment and contract data */
export const authClient = axios.create({});
